<template>
  <div class="home-container fade-in">
    <!-- 广告轮播区域 -->
    <div class="ad-carousel-section modern-card">
      <el-carousel :interval="5000" height="400px" arrow="always" indicator-position="outside">
        <el-carousel-item v-for="(ad, index) in adList" :key="index">
          <div class="ad-item" @click="handleAdClick(ad)">
            <div class="ad-image-wrapper">
              <img :src="ad.image" :alt="ad.title" class="ad-image">
              <div class="ad-overlay"></div>
            </div>
            <div class="ad-content">
              <div class="ad-badge" :class="ad.type">{{ ad.badge }}</div>
              <h2 class="ad-title">{{ ad.title }}</h2>
              <p class="ad-description">{{ ad.description }}</p>
              <div class="ad-company">
                <i class="el-icon-office-building"></i>
                <span>{{ ad.company }}</span>
              </div>
            </div>
          </div>
        </el-carousel-item>
      </el-carousel>
    </div>

    <div class="main-content">
      <!-- 左侧内容区域 -->
      <div class="content-area">
        <!-- 顶部筛选区域 -->
        <div class="filter-section modern-card">
          <!-- 第一行：供应/需求切换 -->
          <div class="filter-row type-filter-row">
            <div class="filter-item type-filter">
              <el-tabs v-model="activeType" @tab-click="handleTypeChange" class="type-tabs">
                <el-tab-pane name="supply">
                  <span slot="label">
                    <i class="el-icon-sell"></i> 供应
                  </span>
                </el-tab-pane>
                <el-tab-pane name="demand">
                  <span slot="label">
                    <i class="el-icon-shopping-cart-2"></i> 需求
                  </span>
                </el-tab-pane>
              </el-tabs>
            </div>
          </div>

          <!-- 第二行：筛选条件 -->
          <div class="filter-row search-filter-row">
            <!-- 行业分类筛选 -->
            <div class="filter-item category-filter">
              <span class="filter-label">
                <i class="el-icon-menu"></i> 行业
              </span>
              <div class="cascader-group">
                <el-select
                    v-model="selectedCategoryId"
                    placeholder="请选择行业"
                    clearable
                    @change="handleCategoryChange"
                    class="category-select">
                  <el-option
                      v-for="category in categoryList"
                      :key="category.id"
                      :label="category.name"
                      :value="category.id">
                  </el-option>
                </el-select>
              </div>
            </div>

            <!-- 地区筛选 -->
            <div class="filter-item category-filter">
              <span class="filter-label">
                <i class="el-icon-location"></i> 地区
              </span>
              <div class="cascader-group">
                <el-cascader
                    v-if="provinceOptions.length > 0"
                    v-model="selectedRegion"
                    :options="provinceOptions"
                    :props="cascaderProps"
                    @change="handleRegionChange"
                    placeholder="请选择省/市/区"
                    style="width: 100%;">
                </el-cascader>
                <el-input
                    v-else
                    v-model="province"
                    placeholder="请输入省/市/区">
                </el-input>
              </div>
            </div>

            <!-- 关键词搜索 -->
            <div class="filter-item search-filter">
              <span class="filter-label">
                <i class="el-icon-search"></i> 搜索
              </span>
              <div class="search-group">
                <el-input
                    v-model="searchKeyword"
                    placeholder="请输入关键词"
                    @keyup.enter.native="handleSearch"
                    class="search-input"
                    prefix-icon="el-icon-search"
                    clearable>
                </el-input>
                <el-button type="primary" @click="handleSearch" class="search-btn" icon="el-icon-search">
                  搜索
                </el-button>
              </div>
            </div>
          </div>
        </div>

        <!-- 热门/最新切换 -->
        <div class="sort-tabs-section modern-card">
          <el-tabs v-model="sortType" @tab-click="handleSortChange" class="sort-tabs">
            <el-tab-pane name="hot">
              <span slot="label">
                <i class="el-icon-s-data"></i> 热门
              </span>
            </el-tab-pane>
            <el-tab-pane name="latest">
              <span slot="label">
                <i class="el-icon-time"></i> 最新
              </span>
            </el-tab-pane>
            <el-tab-pane name="recommend">
              <span slot="label">
                <i class="el-icon-star-on"></i> 推荐
              </span>
            </el-tab-pane>
          </el-tabs>
        </div>

        <!-- 内容列表 -->
        <div class="content-list modern-card" v-loading="loading">
          <div v-for="(item, index) in list" :key="item.id" class="supply-item" @click="viewDetail(item.id)"
               v-if="item && item.id" :style="{'animation-delay': (index * 0.1) + 's'}">
            <!-- 封面图片 -->
            <div class="item-image" @click.stop>
              <el-image
                  v-if="item.coverImage"
                  :src="$fixImageUrl(item.coverImage)"
                  :preview-src-list="[$fixImageUrl(item.coverImage)]"
                  class="cover-img"
                  fit="cover">
                <div slot="error" class="image-error">
                  <i class="el-icon-picture-outline"></i>
                </div>
              </el-image>
              <div v-else class="no-image">
                <i class="el-icon-picture"></i>
                <span>暂无图片</span>
              </div>
            </div>

            <div class="item-main">
              <!-- 标题和徽章 -->
              <div class="item-header">
                <span  class="item-badge badge" :class="item.type === 'supply' ? 'badge-supply' : 'badge-demand'">
                  {{ item.type === 'supply' ? '供' : '需' }}
                </span>
                <h3 class="item-title">{{ item.title }}</h3>
              </div>

              <!-- 公司信息 -->
              <div class="item-company" v-if="item.companyName">
                <i class="el-icon-office-building"></i>
                <span>{{ item.companyName }}</span>
              </div>

              <!-- 标签区域 -->
              <div class="item-tags" v-if="item.categoryNames || item.industryNames">
                <el-tag v-for="(name, index) in (item.categoryNames || [])" :key="'cat'+index" size="small" effect="plain" v-if="name">
                  {{ name }}
                </el-tag>
                <el-tag v-for="(name, index) in (item.industryNames || [])" :key="'ind'+index" size="small"
                        type="success" effect="plain" v-if="name">
                  {{ name }}
                </el-tag>
              </div>

              <div class="item-footer">
                <span class="item-date">
                  <i class="el-icon-time"></i>
                  {{ formatDate(item.createdAt) }}
                </span>

                <!-- 统计信息 -->
                <div class="item-stats">
                  <span class="stat-item" @click.stop="toggleFavorite(item)">
                    <i :class="item.isFavorite ? 'el-icon-star-on' : 'el-icon-star-off'"></i>
                    {{ item.isFavorite ? '已收藏' : '收藏' }}
                  </span>
                  <span class="stat-item">
                    <i class="el-icon-view"></i> {{ item.viewCount || 0 }}
                  </span>
                </div>
              </div>
            </div>

            <!-- 右侧操作按钮 -->
            <div class="item-actions">
              <el-button type="primary" size="small" @click.stop="viewDetail(item.id)" icon="el-icon-document">
                查看详情
              </el-button>
            </div>
          </div>

          <!-- 分页 -->
          <div v-if="total > 0" class="pagination-section">
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handlePageChange"
                :current-page="pageNum"
                :page-sizes="[10, 20, 50]"
                :page-size="pageSize"
                layout="total, sizes, prev, pager, next"
                :total="total">
            </el-pagination>
          </div>

          <!-- 空状态 -->
          <el-empty v-if="list.length === 0 && !loading" description="暂无数据">
            <el-button type="primary" @click="loadList">刷新</el-button>
          </el-empty>
        </div>
      </div>

      <!-- 右侧：发布按钮和线索区域 -->
      <div class="right-sidebar">
        <!-- 发布按钮区域 -->
        <div class="publish-section modern-card" style="margin-bottom: 10px">
          <h3 class="section-title">
            <i class="el-icon-edit"></i> 快速发布
          </h3>
          <div class="publish-buttons">
            <el-button type="danger" 
                       size="medium" 
                       icon="el-icon-edit" 
                       @click="publishDemand"
                       class="publish-btn publish-demand-btn">
              发布需求
            </el-button>
            <el-button type="success"
                       size="medium"
                       icon="el-icon-edit" 
                       @click="publishSupply"
                       class="publish-btn publish-supply-btn">
              发布供应
            </el-button>
          </div>
        </div>

        <!-- 需求线索 -->
        <div class="hot-section modern-card">
          <h3 class="section-title">
            <i class="el-icon-s-flag"></i> 需求线索
          </h3>
          <div class="hot-list">
            <div v-for="(item, index) in hotDemandList" :key="item.id" class="hot-item" @click="viewDetail(item.id)">
              <span class="hot-number">{{ index + 1 }}</span>
              <span class="hot-badge demand">需</span>
              <span class="hot-title">{{ item.title }}</span>
            </div>
          </div>
        </div>

        <!-- 供应线索 -->
        <div class="hot-section modern-card">
          <h3 class="section-title">
            <i class="el-icon-goods"></i> 供应线索
          </h3>
          <div class="hot-list">
            <div v-for="(item, index) in hotSupplyList" :key="item.id" class="hot-item" @click="viewDetail(item.id)">
              <span class="hot-number">{{ index + 1 }}</span>
              <span class="hot-badge supply">供</span>
              <span class="hot-title">{{ item.title }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import request from "@/utils/request";
import { countryList, provinceOptions, countryRegionMap } from "@/utils/regionData";


export default {
  name: "HomeView",
  data() {
    return {
      activeType: 'supply',        // 当前类型：supply/demand
      sortType: 'hot',             // 排序类型：hot/latest
      searchKeyword: '',
      selectedCategoryId: null,    // 选中的产品/领域ID
      selectedIndustryId: null,    // 选中的行业ID
      list: [],
      hotDemandList: [],
      hotSupplyList: [],
      categoryTree: [],           // 完整的分类树数据
      categoryList: [],           // 产品/领域列表（父节点）
      currentIndustries: [],      // 当前可选择的行业列表
      pageNum: 1,
      pageSize: 10,
      total: 0,
      loading: false,
      // 地区筛选
      province: '',
      city: '',
      district: '',
      // 从外部导入国家和省市数据
      countryList: countryList,
      provinceOptions: provinceOptions,
      countryRegionMap: countryRegionMap,
      // 选中的地区
      selectedRegion: [],
      // 级联选择器配置
      cascaderProps: {
        value: 'value',
        label: 'label',
        children: 'children'
      },
      // 广告数据
      adList: [
        {
          id: 1,
          image: 'https://images.unsplash.com/photo-1557804506-669a67965ba0?w=1200&h=400&fit=crop',
          title: '智能制造解决方案',
          description: '为您提供一站式智能制造服务，助力企业数字化转型',
          company: '数海领航科技有限公司',
          badge: '推荐',
          type: 'featured'
        },
        {
          id: 2,
          image: 'https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=1200&h=400&fit=crop',
          title: '供应链管理系统',
          description: '高效的供应链管理，降低成本，提升效率',
          company: '智联供应链管理公司',
          badge: '热门',
          type: 'hot'
        },
        {
          id: 3,
          image: 'https://images.unsplash.com/photo-1551434678-e076c223a692?w=1200&h=400&fit=crop',
          title: '企业数字化转型',
          description: '专业的数字化转型咨询与实施服务',
          company: '云端科技集团',
          badge: '新品',
          type: 'new'
        }
      ],
      // 商户数据
      merchantList: [
        {
          id: 1,
          name: '数海领航科技',
          logo: 'https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png',
          category: '智能制造 · 工业互联网',
          tags: ['认证企业', '金牌服务'],
          productCount: 128,
          rating: 4.9,
          verified: true
        },
        {
          id: 2,
          name: '智联供应链',
          logo: 'https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png',
          category: '供应链管理 · 物流服务',
          tags: ['优质商户', '快速响应'],
          productCount: 96,
          rating: 4.8,
          verified: true
        },
        {
          id: 3,
          name: '云端科技',
          logo: 'https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png',
          category: '云计算 · 大数据',
          tags: ['技术领先', '服务优质'],
          productCount: 156,
          rating: 4.9,
          verified: true
        },
        {
          id: 4,
          name: '绿色能源集团',
          logo: 'https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png',
          category: '新能源 · 环保科技',
          tags: ['绿色认证', '行业领先'],
          productCount: 82,
          rating: 4.7,
          verified: true
        }
      ]
    }
  },
  mounted() {
    this.loadCategories();
    this.loadList();
    this.loadHotDemandList();
    this.loadHotSupplyList();
  },
  methods: {
    // 处理省市区选择
    handleRegionChange(value) {
      if (value && value.length >= 1) {
        // 省份
        this.province = value[0] || '';
        // 城市
        this.city = value[1] || '';
        // 区县
        this.district = value[2] || '';
      } else {
        // 清空地区选择
        this.province = '';
        this.city = '';
        this.district = '';
      }
      // 重新加载列表
      this.pageNum = 1;
      this.loadList();
    },
    // 加载分类数据
    loadCategories() {
      request.get('/category/tree').then(res => {
        if (res.code === '200') {
          this.categoryTree = res.data;
          // 提取第一级分类作为产品/领域列表
          this.categoryList = res.data.map(cat => ({
            id: cat.id,
            name: cat.name,
            children: cat.children
          }));
        }
      });
    },

    // 处理产品/领域选择变化
    handleCategoryChange(categoryId) {
      this.selectedIndustryId = null; // 清空行业选择
      this.currentIndustries = [];

      if (categoryId) {
        // 根据选中的产品/领域，加载对应的行业列表
        const selectedCategory = this.categoryTree.find(cat => cat.id === categoryId);
        if (selectedCategory && selectedCategory.children) {
          this.currentIndustries = selectedCategory.children;
        }
        // console.log('选择产品/领域:', categoryId, ', 可选行业:', this.currentIndustries);
      }

      this.pageNum = 1;
      this.loadList();
    },

    // 处理行业选择变化
    handleIndustryChange() {
      this.pageNum = 1;
      this.loadList();
    },

    // 加载供需列表
    loadList() {
      this.loading = true;

      let apiUrl = '';
      let params = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        type: this.activeType
      };

      // 添加分类筛选参数
      if (this.selectedCategoryId) {
        params.categoryId = this.selectedCategoryId;
      }
      if (this.selectedIndustryId) {
        params.industryId = this.selectedIndustryId;
      }
      
      // 添加地区筛选参数
      if (this.province) {
        params.province = this.province;
      }
      if (this.city) {
        params.city = this.city;
      }
      if (this.district) {
        params.district = this.district;
      }

      if (this.searchKeyword) {
        // 搜索模式
        apiUrl = '/supply-demand/search';
        params.keyword = this.searchKeyword;
      } else if (this.sortType === 'hot') {
        // 热门模式
        apiUrl = '/supply-demand/hot';
        params.limit = this.pageSize * this.pageNum;
      } else if (this.sortType === 'recommend') {
        // 推荐模式
        apiUrl = '/supply-demand/list';
        params.recommended = '1';
      } else {
        // 最新模式
        apiUrl = '/supply-demand/latest';
      }

      // console.log('发送请求:', apiUrl, ', 参数:', params);

      // 统一的请求处理
      request.get(apiUrl, {params}).then(res => {
        // console.log('API响应:', res);

        if (res.code === '200') {
          // 根据API URL判断数据格式，而不是sortType
          if (apiUrl === '/supply-demand/hot' || apiUrl === '/supply-demand/latest') {
            // 热门数据直接是数组
            this.list = res.data || [];
            this.total = this.list.length;
            // console.log('热门数据加载成功:', this.list.length, '条');
          } else {
            // 列表和搜索数据都是分页格式（有records字段）
            this.list = res.data.records || [];
            this.total = parseInt(res.data.total) || 0;
            // console.log('列表数据加载成功:', this.list.length, '条, total:', this.total);
          }

          // 过滤掉null数据，确保渲染安全
          this.list = this.list.filter(item => item != null && item.id != null);
          // console.log('过滤后数据:', this.list.length, '条');

        } else {
          // console.error('API返回错误:', res.msg);
          this.$message.error(res.msg || '加载失败');
          this.list = [];
          this.total = 0;
        }
      }).catch(error => {
        // console.error('请求失败:', error);
        this.$message.error('网络请求失败，请重试');
        this.list = [];
        this.total = 0;
      }).finally(() => {
        // console.log('请求完成，关闭loading');
        this.loading = false;
      });
    },

    // 加载热门需求
    loadHotDemandList() {
      request.get('/supply-demand/hot', {
        params: {
          type: 'demand',
          limit: 8
        }
      }).then(res => {
        if (res.code === '200') {
          this.hotDemandList = res.data || [];
        }
      }).catch(error => {
        // console.error('加载热门需求失败:', error);
        this.hotDemandList = [];
      });
    },

    // 加载热门供应
    loadHotSupplyList() {
      request.get('/supply-demand/hot', {
        params: {
          type: 'supply',
          limit: 8
        }
      }).then(res => {
        if (res.code === '200') {
          this.hotSupplyList = res.data || [];
        }
      }).catch(error => {
        // console.error('加载热门供应失败:', error);
        this.hotSupplyList = [];
      });
    },

    // 发布需求
    publishDemand() {
      this.$router.push({
        path: '/publish',
        query: {type: 'demand'}
      });
    },

    // 发布供应
    publishSupply() {
      this.$router.push({
        path: '/publish',
        query: {type: 'supply'}
      });
    },

    // 类型切换
    handleTypeChange() {
      this.pageNum = 1;
      this.loadList();
    },

    // 排序切换
    handleSortChange() {
      this.pageNum = 1;
      this.loadList();
    },


    // 搜索
    handleSearch() {
      this.pageNum = 1;
      this.loadList();
    },

    // 查看详情
    viewDetail(id) {
      this.$router.push(`/supply-demand/detail/${id}`);
    },

    // 切换收藏
    toggleFavorite(item) {
      if (item.isFavorite) {
        request.delete('/favorite', {
          params: {supplyDemandId: item.id}
        }).then(res => {
          if (res.code === '200') {
            this.$message.success('已取消收藏');
            item.isFavorite = false;
          }
        });
      } else {
        request.post('/favorite', null, {
          params: {supplyDemandId: item.id}
        }).then(res => {
          if (res.code === '200') {
            this.$message.success('收藏成功');
            item.isFavorite = true;
          }
        });
      }
    },

    // 分页
    handlePageChange(page) {
      this.pageNum = page;
      window.scrollTo({top: 0, behavior: 'smooth'});
      this.loadList();
    },

    handleSizeChange(size) {
      this.pageSize = size;
      this.pageNum = 1;
      this.loadList();
    },

    // 格式化日期
    formatDate(date) {
      if (!date) return '';
      const d = new Date(date);
      return d.getFullYear() + '-' +
          String(d.getMonth() + 1).padStart(2, '0') + '-' +
          String(d.getDate()).padStart(2, '0');
    },

    // 广告点击
    handleAdClick(ad) {
      this.$message.info(`点击了广告：${ad.title}`);
      // 可以跳转到广告详情页或商户页面
    },

    // 查看所有商户
    viewAllMerchants() {
      this.$message.info('跳转到商户列表页');
      // this.$router.push('/merchants');
    },

    // 查看商户详情
    viewMerchantDetail(merchant) {
      this.$message.info(`查看商户：${merchant.name}`);
      // this.$router.push(`/merchant/${merchant.id}`);
    }
  }
}
</script>

<style scoped>
/* ========== 页面容器 ========== */
.home-container {
  padding: 0;
  background: #f5f7fa;
  min-height: 100vh;
}

.home-container > .ad-carousel-section {
  max-width: 100%;
  margin: 0;
  padding: 0;
  border-radius: 0;
}

/* ========== 广告轮播区域 ========== */
.ad-carousel-section {
  margin-bottom: 0;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.ad-carousel-section ::v-deep .el-carousel__container {
  overflow: hidden;
}

.ad-item {
  position: relative;
  width: 100%;
  height: 400px;
  cursor: pointer;
  overflow: hidden;
}

.ad-image-wrapper {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.ad-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.5s ease;
}

.ad-item:hover .ad-image {
  transform: scale(1.05);
}

.ad-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(to right, rgba(0, 0, 0, 0.7) 0%, rgba(0, 0, 0, 0.3) 60%, transparent 100%);
}

.ad-content {
  position: absolute;
  top: 50%;
  left: 60px;
  transform: translateY(-50%);
  color: white;
  z-index: 2;
  max-width: 500px;
}

.ad-badge {
  display: inline-block;
  padding: 6px 16px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 600;
  margin-bottom: 16px;
  text-transform: uppercase;
  letter-spacing: 1px;
}

.ad-badge.featured {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
}

.ad-badge.hot {
  background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);
}

.ad-badge.new {
  background: linear-gradient(135deg, #4facfe 0%, #00f2fe 100%);
}

.ad-title {
  font-size: 36px;
  font-weight: 700;
  margin: 0 0 16px 0;
  text-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);
  line-height: 1.2;
}

.ad-description {
  font-size: 16px;
  margin: 0 0 20px 0;
  opacity: 0.95;
  line-height: 1.6;
}

.ad-company {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  opacity: 0.9;
}

.ad-company i {
  font-size: 16px;
}

/* ========== 商户推荐区域 ========== */
.merchant-section {
  margin-bottom: 0;
  padding: 30px;
  border-radius: 16px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
}

.section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  padding-bottom: 16px;
  border-bottom: 2px solid #f0f0f0;
}

.section-title {
  margin: 0;
  font-size: 20px;
  font-weight: 600;
  color: #303133;
  display: flex;
  align-items: center;
  gap: 8px;
}

.section-title i {
  color: #ffd700;
  font-size: 22px;
}

.more-btn {
  font-size: 14px;
  color: #667eea;
  padding: 0;
}

.more-btn:hover {
  color: #764ba2;
}

.merchant-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
  gap: 20px;
}

.merchant-card {
  background: white;
  border: 1px solid #ebeef5;
  border-radius: 12px;
  padding: 20px;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

.merchant-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 24px rgba(102, 126, 234, 0.15);
  border-color: #667eea;
}

.merchant-logo {
  position: relative;
  width: 80px;
  height: 80px;
  margin-bottom: 16px;
}

.merchant-logo img {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  object-fit: cover;
  border: 3px solid #f0f0f0;
}

.verified-badge {
  position: absolute;
  bottom: -2px;
  right: -2px;
  width: 24px;
  height: 24px;
  background: linear-gradient(135deg, #52c41a 0%, #73d13d 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 2px solid white;
  box-shadow: 0 2px 8px rgba(82, 196, 26, 0.3);
}

.verified-badge i {
  color: white;
  font-size: 12px;
  font-weight: bold;
}

.merchant-info {
  width: 100%;
}

.merchant-name {
  margin: 0 0 8px 0;
  font-size: 16px;
  font-weight: 600;
  color: #303133;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.merchant-category {
  margin: 0 0 12px 0;
  font-size: 13px;
  color: #909399;
}

.merchant-tags {
  margin-bottom: 12px;
  display: flex;
  gap: 6px;
  justify-content: center;
  flex-wrap: wrap;
}

.merchant-stats {
  display: flex;
  justify-content: space-around;
  padding-top: 12px;
  border-top: 1px solid #f0f0f0;
  font-size: 13px;
  color: #606266;
}

.merchant-stats span {
  display: flex;
  align-items: center;
  gap: 4px;
}

.merchant-stats i {
  color: #ffd700;
}

/* ========== 主要内容区域 ========== */
.main-content {
  display: flex;
  gap: 20px;
  align-items: flex-start;
  max-width: 1600px;
  margin: 0 auto;
  padding: 20px;
}

/* 左侧内容区域 */
.content-area {
  flex: 1;
  min-width: 0;
}

/* ========== 筛选区域 ========== */
.filter-section {
  margin-bottom: 15px;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  padding: 20px;
}

.modern-card {
  background: white;
}

/* 筛选行布局 */
.filter-row {
  display: flex;
  align-items: center;
}

/* 第一行：供应/需求切换（单独一行） */
.type-filter-row {
  width: 100%;
  margin-bottom: 20px;
  padding-bottom: 20px;
  border-bottom: 1px solid #ebeef5;
}

.type-filter {
  display: flex;
  align-items: center;
  gap: 15px;
  width: 100%;
}

.type-tabs ::v-deep .el-tabs__header {
  margin: 0;
}

.type-tabs ::v-deep .el-tabs__nav-wrap::after {
  height: 2px;
}

/* 第二行：行业分类和搜索（同一行） */
.search-filter-row {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 20px;
}

.category-filter {
  display: flex;
  align-items: center;
  gap: 15px;
  flex: 1;
}

.search-filter {
  display: flex;
  align-items: center;
  gap: 15px;
  flex: 1;
  justify-content: flex-end;
}

.filter-label {
  color: #606266;
  font-size: 14px;
  white-space: nowrap;
  font-weight: 500;
}

/* 级联选择器组 */
.cascader-group {
  display: flex;
  align-items: center;
  gap: 10px;
  flex: 1;
}

.category-select,
.industry-select {
  min-width: 150px;
}

/* 搜索组 */
.search-group {
  display: flex;
  align-items: center;
  gap: 10px;
  flex: 1;
  max-width: 400px;
  justify-content: flex-end;
}

.search-input {
  flex: 1;
  min-width: 180px;
}

/* 排序标签区域 */
.sort-tabs-section {
  background: white;
  border-radius: 8px;
  padding: 0 20px;
  margin-bottom: 15px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}

.sort-tabs ::v-deep .el-tabs__header {
  margin: 0;
}

.sort-tabs ::v-deep .el-tabs__nav-wrap::after {
  height: 2px;
}

.sort-tabs ::v-deep .el-tabs__content {
  display: none;
}

/* 内容列表 */
.content-list {
  background: white;
  border-radius: 10px;
  padding: 20px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  min-height: 500px;
}

/* 供需项目样式 - 保持不变 */
.supply-item {
  display: flex;
  align-items: flex-start;
  padding: 20px;
  border-bottom: 1px solid #EBEEF5;
  cursor: pointer;
  transition: background-color 0.3s;
  gap: 15px;
}

.supply-item:hover {
  background-color: #f8f9fa;
}

.supply-item:last-child {
  border-bottom: none;
}

/* 右侧边栏 */
.right-sidebar {
  width: 280px;
  flex-shrink: 0;
}

/* 响应式设计 */
@media (max-width: 1200px) {
  .main-content {
    flex-direction: column;
  }

  .right-sidebar {
    width: 100%;
  }

  .search-filter-row {
    flex-direction: column;
    gap: 15px;
  }

  .category-filter,
  .search-filter {
    width: 100%;
    justify-content: flex-start;
  }

  .search-group {
    max-width: 100%;
  }

  .merchant-grid {
    grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
  }

  .ad-content {
    left: 40px;
    max-width: 400px;
  }

  .ad-title {
    font-size: 28px;
  }
}

@media (max-width: 768px) {
  .filter-section {
    padding: 15px;
  }

  .type-filter-row,
  .search-filter-row {
    flex-direction: column;
    gap: 15px;
  }

  .type-filter,
  .category-filter,
  .search-filter {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
    width: 100%;
  }

  .cascader-group {
    width: 100%;
  }

  .category-select,
  .industry-select {
    width: 100%;
  }

  .search-group {
    width: 100%;
    max-width: 100%;
  }

  .merchant-grid {
    grid-template-columns: 1fr;
  }

  .ad-carousel-section ::v-deep .el-carousel {
    height: 280px !important;
  }

  .ad-item {
    height: 280px;
  }

  .ad-content {
    left: 20px;
    right: 20px;
    max-width: none;
  }

  .ad-title {
    font-size: 24px;
  }

  .ad-description {
    font-size: 14px;
  }
}

.type-tabs ::v-deep .el-tabs__header {
  margin: 0;
}

.type-tabs ::v-deep .el-tabs__nav-wrap::after {
  height: 2px;
}

.sort-tabs ::v-deep .el-tabs__header {
  margin: 0;
}

.sort-tabs ::v-deep .el-tabs__content {
  display: none;
}

/* 内容列表 */
.content-list {
  background: white;
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  min-height: 600px;
}

/* 供需项目样式 */
.supply-item {
  display: flex;
  align-items: flex-start;
  padding: 16px;
  border-bottom: 1px solid #EBEEF5;
  cursor: pointer;
  transition: background-color 0.3s;
  gap: 15px;
}

.supply-item:hover {
  background-color: #f8f9fa;
}

.supply-item:last-child {
  border-bottom: none;
}

/* 封面图片 */
.item-image {
  width: 120px;
  height: 90px;
  border-radius: 6px;
  overflow: hidden;
  flex-shrink: 0;
  background: #f5f7fa;
}

.cover-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.no-image {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #c0c4cc;
  font-size: 24px;
}

.item-main {
  flex: 1;
  min-width: 0;
}

.item-header {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  margin-bottom: 10px;
}

.item-badge {
  color: #fffefe;
  width: 22px;
  height: 22px;
  border-radius: 3px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 11px;
  font-weight: bold;
  flex-shrink: 0;
}

.badge-supply {
  background: linear-gradient(135deg, #51cf66 0%, #37b24d 100%);
}

.badge-demand {
  background: linear-gradient(135deg, #ff6b6b 0%, #ff8e53 100%);
}

.item-title {
  margin: 0;
  font-size: 16px;
  font-weight: 500;
  color: #303133;
  line-height: 1.4;
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.item-tags {
  margin-bottom: 15px;
}

.item-tags .el-tag {
  margin-right: 8px;
  margin-bottom: 5px;
}

.item-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.item-date {
  color: #909399;
  font-size: 14px;
}

.item-stats {
  display: flex;
  gap: 15px;
  align-items: center;
}

.stat-item {
  color: #909399;
  font-size: 12px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 4px;
  white-space: nowrap;
}

.stat-item:hover {
  color: #409EFF;
}

.stat-item i {
  font-size: 14px;
}

/* 发布按钮区域 */
.publish-section {
  background: white;
  border-radius: 16px;
  padding: 20px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
}

.publish-section .section-title {
  margin: 0 0 15px 0;
  font-size: 16px;
  font-weight: 600;
  color: #303133;
  display: flex;
  align-items: center;
  gap: 8px;
}

.publish-buttons {
  display: flex;
  gap: 10px;
}

.publish-btn {
  flex: 1;
  font-weight: 600;
  font-size: 14px;
  padding: 10px 8px;
}

.publish-btn >>> span {
  font-size: 14px;
}

/* 热门区域 */
.hot-section {
  background: white;
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 15px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}

.hot-section h3 {
  margin: 0 0 15px 0;
  color: #303133;
  font-size: 16px;
  padding-bottom: 10px;
  border-bottom: 2px solid #F56C6C;
}

.hot-list {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.hot-item {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  cursor: pointer;
  padding: 10px;
  border-radius: 6px;
  transition: background-color 0.3s;
}

.hot-item:hover {
  background-color: #f8f9fa;
}

.hot-badge {
  background: #E74C3C;
  color: white;
  width: 20px;
  height: 20px;
  border-radius: 3px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 10px;
  font-weight: bold;
  flex-shrink: 0;
}

.hot-badge.supply {
  background: #52A834;
}

.hot-title {
  flex: 1;
  font-size: 14px;
  color: #606266;
  line-height: 1.4;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.pagination-section {
  margin-top: 30px;
  display: flex;
  justify-content: center;
}

/* 响应式设计 */
@media (max-width: 1200px) {
  .main-content {
    flex-direction: column;
  }

  .right-sidebar {
    width: 100%;
  }

  .filter-row {
    flex-direction: column;
    gap: 15px;
  }

  .filter-item {
    width: 100%;
    justify-content: space-between;
  }
}
</style>